import React, { useState, useEffect, useRef } from 'react';  
import { Link } from 'react-router-dom';
import { Dropdown, Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { get_AstroData, get_AstrologerSingleData } from '../../../store/actions/CommanAction';
import { setAstroId } from '../../../store/Action_Types';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import user from './../../../images/task/user.jpg';
import Loader from '../Loader/Loader';
import * as XLSX from 'xlsx';
import AstrologerListModal from './AstrologerListModal';

const BlockedAstrologer = () => {
   const dispatch = useDispatch();
     const effectRan = useRef(false);
     const AstroData = useSelector((state) => state.feedBackReducer.AstroData);
  
     const customerID = Number(sessionStorage.getItem('ID'));
 
     const [IsActive, setIsActive] = useState(true);
     const [searchQuery, setSearchQuery] = useState('');
     const [AstrologerID, seAstrologerID] = useState('');
     const [startTime, setStartTime] = useState('');
     const [endTime, setEndTime] = useState('');
     const [searchQuery1, setSearchQuery1] = useState('');
     const [mobileNumber, setMobileNumber] = useState('');
     const [name, setName] = useState('');
     const [location, setLocation] = useState('');
     const [loading, setLoading] = useState(false);
     const [timeoutId, setTimeoutId] = useState(null);
     const [filters, setFilters] = useState({ name: '', mobile: '', status: '' });
     const [sortField, setSortField] = useState('');
     const [sortOrder, setSortOrder] = useState('asc');
     const [currentPage, setCurrentPage] = useState(1);
     const itemsPerPage = 10;
     const [showModal, setShowModal] = useState(false);
     const [astrodata,setAstrodata]=useState([])
     const [activeTab, setActiveTab] = useState("basic");
     const [form, setForm] = useState({
         name: "",
         mobile: "",
         email: "",
         dob: "",
         dot: "",
         placeOfBirth: "",
         address: "",
         city: "",
         pinCode: "",
         panCard: "",
         aadhar: "",
         maritalStatus: "",
         gender: "",
         image: null,
         imagePreview: null,
         aboutMe: "",
         qualification: "",
         bankName: "",
         accountNumber: "",
         ifscCode: "",
         branchName: "",
         attachment: null,
         attachmentName: "",
         attachmentPreview: null,
         review: "",
     });
 
     
     useEffect(() => {
         if (!effectRan.current) {
             dispatch(get_AstroData(setLoading, "1"));
             effectRan.current = true;
         }
     }, [dispatch]);
    
 
     useEffect(() => {
         if (name.length < 3 && location.length < 3 && mobileNumber.length < 3) return;
 
         if (timeoutId) clearTimeout(timeoutId);
 
         const newTimeoutId = setTimeout(() => {
             setLoading(true);
             dispatch(get_AstroData(IsActive ? '1' : '0', startTime, endTime, name, mobileNumber, location, setLoading));
         }, 500);
 
         setTimeoutId(newTimeoutId);
         return () => clearTimeout(newTimeoutId);
     }, [name, location, mobileNumber]);
 
     const handleAddAstrologerClick = (ID) => {
         dispatch(setAstroId(ID));
         seAstrologerID(ID);
     };
 
     
     const handleToggleStatusClick1 = async (AstroId, currentIsBlock) => {
      
         const postData = {                     
             AstroId,
             IsBlock: !currentIsBlock,
             BlockReason: null
         };
         await AddUpdate('Astrologer/UpdateAstrologerBlock', postData);
         dispatch(get_AstroData(setLoading));
         swal('Success', `${!currentIsBlock ? 'Astrologer has been blocked' : 'Astrologer has been unblocked'}`, 'success');
     };
 





     const filteredAstroData = AstroData?.filter((item) => {
         const query = searchQuery.toLowerCase();
         return (
             item.DisplayName?.toLowerCase().includes(query) ||
             item.EMPID?.toLowerCase().includes(query) ||
             item.RegMobileNo?.toLowerCase().includes(query) ||
             item.EmailID?.toLowerCase().includes(query)
         );
     });
 
     // Filter and sort the data
     const getFilteredAndSortedData = () => {
         let filteredData = AstroData || [];
 
         // Apply filters
         if (filters.name) {
             filteredData = filteredData.filter(item =>
                 item.DisplayName?.toLowerCase().includes(filters.name.toLowerCase())
             );
         }
         if (filters.mobile) {
             filteredData = filteredData.filter(item =>
                 item.RegMobileNo?.includes(filters.mobile)
             );
         }
         if (filters.status) {
             filteredData = filteredData.filter(item =>
                 filters.status === 'active' ? item.IsActive : !item.IsActive
             );
         }
 
         // Apply sorting
         if (sortField) {
             filteredData.sort((a, b) => {
                 const aValue = a[sortField];
                 const bValue = b[sortField];
 
                 if (typeof aValue === 'string' && typeof bValue === 'string') {
                     return sortOrder === 'asc'
                         ? aValue.localeCompare(bValue)
                         : bValue.localeCompare(aValue);
                 }
 
                 return sortOrder === 'asc'
                     ? (aValue > bValue ? 1 : -1)
                     : (aValue < bValue ? 1 : -1);
             });
         }
 
         return filteredData;
     };
 
     // Get paginated data
     const getPaginatedData = () => {
         const filteredData = getFilteredAndSortedData();
         // If status is "All", return all data without pagination
         if (filters.status === '') {
             return filteredData;
         }
         const startIndex = (currentPage - 1) * itemsPerPage;
         return filteredData.slice(startIndex, startIndex + itemsPerPage);
     };
 
     // Handle filter changes
     const handleFilterChange = (field, value) => {
         setFilters(prev => ({ ...prev, [field]: value }));
         setCurrentPage(1); // Reset to first page on filter change
     };
 
     // Handle sort
     const handleSort = (field) => {
         const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
         setSortField(field);
         setSortOrder(order);
     };
 
     // Handle page change
     const handlePageChange = (event, newPage) => {
         setCurrentPage(newPage);
     };
 
     // Export to Excel
     const exportToExcel = () => {
         const dataToExport = getFilteredAndSortedData().map(astro => ({
             'Name': astro.DisplayName || 'N/A',
             'Mobile': astro.RegMobileNo || 'N/A',
             'Gender': astro.Gender || 'N/A',
             'Rating': astro.Rating || '0',
             'Skill': astro.Skill || 'N/A',
             'Total Orders': astro.TotalOrders || '0',
             'Followers': astro.Followers || '0',
             'Status': astro.IsActive ? 'Active' : 'Inactive'
         }));
 
         const worksheet = XLSX.utils.json_to_sheet(dataToExport);
         const workbook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(workbook, worksheet, 'Astrologers');
         XLSX.writeFile(workbook, 'Astrologers_List.xlsx');
     };
 
     // Reset filters
     const handleResetFilters = () => {
         setFilters({ name: '', mobile: '', status: '' });
         setSortField('');
         setSortOrder('asc');
         setCurrentPage(1);
     };
 
     // Handle edit click
     const handleEditClick = (astro) => {
         dispatch(get_AstrologerSingleData(astro.ID));
     };
 

 
     const handleCloseModal = () => {
         setShowModal(false);
     };
 
     const handleFormChange = (e) => {
         const { name, value, files } = e.target;
         if (name === "image") {
             const file = files[0];
             setForm((prev) => ({
                 ...prev,
                 image: file,
                 imagePreview: URL.createObjectURL(file),
             }));
         } else if (name === "attachment") {
             const file = files[0];
             setForm((prev) => ({
                 ...prev,
                 attachment: file,
                 attachmentName: file.name,
                 attachmentPreview: URL.createObjectURL(file),
             }));
         } else {
             setForm((prev) => ({ ...prev, [name]: value }));
         }
     };
 
     const handleFormSubmit = (e) => {
         e.preventDefault();
     
         swal('Success', 'Profile saved successfully!', 'success');
         handleCloseModal();
     };

     const handleToggleChange = (row) => {
  const updatedRow = {
    ...row,
    IsBlock: !row.IsBlock, 
  };

  

};

 
  useEffect(()=>{
        setAstrodata(AstroData)
      
     },[astrodata])
 
     const columns = [
         {
             name: 'Image',
             selector: row => row.AvatarUrl,
             cell: row => (
                 <img
                     src={row.AvatarUrl ? `https://${row.AvatarUrl.replace(/\\/g, "/")}` : user}
                     alt={row.DisplayName || 'Astrologer'}
                     className="rounded-circle"
                     style={{ width: '40px', height: '40px', objectFit: 'cover', border: '1px solid #ddd' }}
                     onError={(e) => {
                         e.target.onerror = null;
                         e.target.src = user;
                     }}
                 />
             ),
             width: '80px'
         },
         {
             name: 'Name',
             selector: row => row.DisplayName,
             sortable: true,
             cell: row => row.DisplayName || 'N/A'
         },
         {
             name: 'Mobile',
             selector: row => row.RegMobileNo,
             sortable: true,
             cell: row => row.RegMobileNo || 'N/A'
         },
         {
             name: 'Gender',
             selector: row => row.Gender,
             sortable: true,
             cell: row => row.Gender || 'N/A'
         },
         {
             name: 'Rating',
             selector: row => row.Rating,
             sortable: true,
             cell: row => row.Rating || '0'
         },
         
         {
             name: 'Total Order',
             selector: row => row.TotalOrders,
             sortable: true,
             cell: row => row.TotalOrders || '0'
         },
         {
             name: 'Followers',
             selector: row => row.Followers,
             sortable: true,
             cell: row => row.Followers || '0'
         },           //changes
     {
  name: 'Actions',
  cell: row => (
    <Form.Check
    style={{cursor:"pointer"}}
      type="switch"
      id={`custom-switch-${row.ID}`}
      label={row.IsBlock ? 'On' : 'Off'} 
      checked={row.IsBlock} 
      onChange={() => handleToggleStatusClick1(row.ID, row.IsBlock, false)}
    />
  )
}


   

     ];
 
     if (loading) {
         return <Loader />;
     }
 
     return (
         <div className="card">
            

             <AstrologerListModal
                 show={showModal}
                 onHide={handleCloseModal}
             />
 
             <div className="card-body">
                 <Row className="mb-3">
                     <Col xs={12} md={3}>
                         <Form.Group controlId="searchName">
                             <Form.Control
                                 type="text"
                                 placeholder="Search Name"
                                 value={filters.name}
                                 onChange={(e) => setFilters(prev => ({ ...prev, name: e.target.value }))}
                                 size="sm"
                             />
                         </Form.Group>
                     </Col>
                     <Col xs={12} md={3}>
                         <Form.Group controlId="searchMobile">
                             <Form.Control
                                 type="text"
                                 placeholder="Search Mobile"
                                 value={filters.mobile}
                                 onChange={(e) => setFilters(prev => ({ ...prev, mobile: e.target.value }))}
                                 size="sm"
                             />
                         </Form.Group>
                     </Col>
                     
                     <Col xs={12} md={3} className="d-flex align-items-end">
                         <Row className="w-100 g-2">
                             <Col xs={6}>
                                 <Button
                                     variant="warning"
                                     className="w-100"
                                     onClick={handleResetFilters}
                                 >Apply Filters
                                 </Button>
                             </Col>
                           
                         </Row>
                     </Col>
                 </Row>
                 <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '70vh' }}>
                     <DataTable
                         columns={columns}
                         data={getFilteredAndSortedData()}
                         pagination
                         paginationPerPage={itemsPerPage}
                         paginationRowsPerPageOptions={[10, 25, 50, 100]}
                         highlightOnHover
                         pointerOnHover
                         customStyles={customStyles}
                         noHeader
                         defaultSortFieldId={1}
                         defaultSortAsc={true}
                         persistTableHead
                         responsive
                         fixedHeader
                         fixedHeaderScrollHeight="60vh"
                     />
                 </div>
             </div>
         </div>
     );
 }

export default BlockedAstrologer